const projects = [
  {
    name: "Letty's Cakes",
    description:
      "Website created for Letty's Cakes, a Venezuelan baking business. This website was created using React JavaScript, Node.js, express and MongoDB, for data storage. This website has full CRUD functionality, allowing the admin to create new desserts, display, edit and delete them, as well as allowing all other users to place orders for the admin to view and delete.",
    imageSrc: "/lettyscakes.png",
    url: "https://lettyscakes.netlify.app/",
  },
  {
    name: "Cat-astrophe",
    description:
      "Cat-astrophe is a short game where you get to play as Catrina, a destructive cat that is left alone at home while her owner goes to the store. Your objective in this game is to break all possible objects inside the house before the Human gets back home, but not all objects are destroyable, have fun finding out which ones you can destroy! This little web game was developed using JavaScript Canvas.",
    imageSrc: "/catastrophe.png",
    url: "https://andriwt.github.io/cat-astrophe/",
  },
  {
    name: "W/O Contaxt",
    description:
      "Without Contaxt is a messaging app that allows you to connect and chat in real time with any other user in the platform, just sign-up to create your profile and pick someone you find interesting to start a chat with! This messaging app was created using Socket.io, for real time message delivery, React Javascript, Node.js, express and MongoDB for data storage, including messages, which are stored based on each individual chat, allowing you to come back at a later time and view all sent messages inside each chat. Authentication is in place for user signup and login",
    imageSrc: "/wocontaxt.png",
    url: "https://withoutcontaxt.netlify.app/",
  },
  {
    name: "Treesitos",
    description:
      "Treesitos is a website that invites you to plant flora around your area and add it to the treesitos map! A little incentive to work towards a greener environment and leave your mark. This is a collaborative work made for Shellhacks 2021, were my collaboration involved backend structure, part of the front end development along with CSS and design. Created using React JavaScript, Node.js, express and MongoDB, with google maps API implementation.",
    imageSrc: "/treesitos.png",
    url: "https://rocky-shore-48903.herokuapp.com/home",
  },
  {
    name: "AT-Pokedex",
    description:
      "AT-Pokedex is an old-school inspired encyclopedia for Pokemon. Using the public pokeapi, you can type the name or number of any of the 898 pokemon that exist and get immediate information back, including evolutions, triggers, stats, descriptions and more! Just like the real thing from the original anime. This app was developed as a practice for manipulating and fetching data with axios from a public API, as well as an HTML/CSS practice",
    imageSrc: "/at-pokedex.png",
    url: "https://at-pokedex.netlify.app/",
  },
];

export default projects;
